export type StudentView = "anonymous" | "cloud" | "projects";
export type MigrationFailureKind = "other" | "project-limit";

export const loginStudentState = <Session>(session: Session) => ({
    pendingGuestMigration: true,
    session,
});

export const migrationFailureKind = (error: unknown): MigrationFailureKind =>
    error instanceof Error && error.message === "PROJECT_LIMIT_REACHED" ? "project-limit" : "other";

export const visibleMigrationStatus = (
    editorStatus: string,
    migrationFailure: MigrationFailureKind | undefined,
    projectLimitMessage: string,
): string => migrationFailure === "project-limit" ? projectLimitMessage : editorStatus;

export const selectStudentView = ({
    authenticated,
    hasProject,
    pendingGuestMigration,
    showProjects,
}: {
    authenticated: boolean;
    hasProject: boolean;
    pendingGuestMigration: boolean;
    showProjects: boolean;
}): StudentView => {
    if (!authenticated) return "anonymous";
    if (showProjects) return "projects";
    if (pendingGuestMigration) return "anonymous";
    return hasProject ? "cloud" : "projects";
};

export const shouldClearAnonymousDraftOnLogout = (pendingGuestMigration: boolean): boolean =>
    !pendingGuestMigration;
